import PropTypes from 'prop-types';
import React from 'react';
import {
  Dialog,
  withStyles,
 } from '@material-ui/core';

const styles = () => ({
  root: {
    padding: '0px 20px',
    maxWidth: '556px',
    width: 'auto',
    fontFamily: 'Roboto, sans-serif',
    margin: 'auto',
  },
  paper: {
    margin: 0,
    width: '100%',
  }
});

const DialogListPicker = ({children, open, classes}) => (
  <Dialog
    fullWidth
    open={open}
    classes={classes}
  >
    {children}
  </Dialog>
);

DialogListPicker.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  classes: PropTypes.object,
};

export default withStyles(styles)(DialogListPicker);



// WEBPACK FOOTER //
// ./src/ondemand/components/DialogListPicker.js